import { IHoliday } from "../holidayTypes";

export const CanadaHolidays: { [key: string]: IHoliday } = {

// 2025
"2025-01-01": { title: "New Year's Day", type: "HOLIDAY" },
"2025-02-17": { title: "Family Day", type: "HOLIDAY" }, // AB, BC, NB, ON, SK
"2025-03-17": { title: "St. Patrick's Day", type: "SPECIAL_DAY" },
"2025-04-18": { title: "Good Friday", type: "HOLIDAY" },
"2025-04-20": { title: "Easter Sunday", type: "SPECIAL_DAY" },
"2025-04-21": { title: "Easter Monday", type: "HOLIDAY" }, // QC
"2025-05-11": { title: "Mother's Day", type: "SPECIAL_DAY" },
"2025-05-19": { title: "Victoria Day", type: "HOLIDAY" },
"2025-06-15": { title: "Father's Day", type: "SPECIAL_DAY" },
"2025-06-21": { title: "National Indigenous Peoples Day", type: "HOLIDAY" }, // NT, YT
"2025-06-24": { title: "Saint-Jean-Baptiste Day", type: "HOLIDAY" }, // QC
"2025-07-01": { title: "Canada Day", type: "HOLIDAY" },
"2025-08-04": { title: "Civic Holiday", type: "HOLIDAY" }, // AB, BC, NB, NU, NT, ON, SK
"2025-09-01": { title: "Labour Day", type: "HOLIDAY" },
"2025-09-30": { title: "National Day for Truth and Reconciliation", type: "HOLIDAY" },
"2025-10-13": { title: "Thanksgiving Day", type: "HOLIDAY" },
"2025-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
"2025-11-11": { title: "Remembrance Day", type: "HOLIDAY" },
"2025-12-24": { title: "Christmas Eve", type: "SPECIAL_DAY" },
"2025-12-25": { title: "Christmas Day", type: "HOLIDAY" },
"2025-12-26": { title: "Boxing Day", type: "HOLIDAY" },
"2025-12-31": { title: "New Year's Eve", type: "SPECIAL_DAY" },

// 2026
"2026-01-01": { title: "New Year's Day", type: "HOLIDAY" },
"2026-02-16": { title: "Family Day", type: "HOLIDAY" }, // AB, BC, NB, ON, SK
"2026-03-17": { title: "St. Patrick's Day", type: "SPECIAL_DAY" },
"2026-04-03": { title: "Good Friday", type: "HOLIDAY" },
"2026-04-05": { title: "Easter Sunday", type: "SPECIAL_DAY" },
"2026-04-06": { title: "Easter Monday", type: "HOLIDAY" }, // QC
"2026-05-10": { title: "Mother's Day", type: "SPECIAL_DAY" },
"2026-05-18": { title: "Victoria Day", type: "HOLIDAY" },
"2026-06-21": { title: "Father's Day", type: "SPECIAL_DAY" },
"2026-06-24": { title: "Saint-Jean-Baptiste Day", type: "HOLIDAY" }, // QC
"2026-07-01": { title: "Canada Day", type: "HOLIDAY" },
"2026-08-03": { title: "Civic Holiday", type: "HOLIDAY" }, // AB, BC, NB, NU, NT, ON, SK
"2026-09-07": { title: "Labour Day", type: "HOLIDAY" },
"2026-09-30": { title: "National Day for Truth and Reconciliation", type: "HOLIDAY" },
"2026-10-12": { title: "Thanksgiving Day", type: "HOLIDAY" },
"2026-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
"2026-11-11": { title: "Remembrance Day", type: "HOLIDAY" },
"2026-12-24": { title: "Christmas Eve", type: "SPECIAL_DAY" },
"2026-12-25": { title: "Christmas Day", type: "HOLIDAY" },
"2026-12-26": { title: "Boxing Day", type: "HOLIDAY" },
"2026-12-31": { title: "New Year's Eve", type: "SPECIAL_DAY" },

// 2027
"2027-01-01": { title: "New Year's Day", type: "HOLIDAY" },
"2027-02-15": { title: "Family Day", type: "HOLIDAY" }, // AB, BC, NB, ON, SK
"2027-03-17": { title: "St. Patrick's Day", type: "SPECIAL_DAY" },
"2027-03-26": { title: "Good Friday", type: "HOLIDAY" },
"2027-03-28": { title: "Easter Sunday", type: "SPECIAL_DAY" },
"2027-03-29": { title: "Easter Monday", type: "HOLIDAY" }, // QC
"2027-05-09": { title: "Mother's Day", type: "SPECIAL_DAY" },
"2027-05-24": { title: "Victoria Day", type: "HOLIDAY" },
"2027-06-20": { title: "Father's Day", type: "SPECIAL_DAY" },
"2027-06-21": { title: "National Indigenous Peoples Day", type: "HOLIDAY" }, // NT, YT
"2027-06-24": { title: "Saint-Jean-Baptiste Day", type: "HOLIDAY" }, // QC
"2027-07-01": { title: "Canada Day", type: "HOLIDAY" },
"2027-08-02": { title: "Civic Holiday", type: "HOLIDAY" }, // AB, BC, NB, NU, NT, ON, SK
"2027-09-06": { title: "Labour Day", type: "HOLIDAY" },
"2027-09-30": { title: "National Day for Truth and Reconciliation", type: "HOLIDAY" },
"2027-10-11": { title: "Thanksgiving Day", type: "HOLIDAY" },
"2027-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
"2027-11-11": { title: "Remembrance Day", type: "HOLIDAY" },
"2027-12-24": { title: "Christmas Eve", type: "SPECIAL_DAY" },
"2027-12-25": { title: "Christmas Day", type: "HOLIDAY" },
"2027-12-26": { title: "Boxing Day", type: "HOLIDAY" },
"2027-12-31": { title: "New Year's Eve", type: "SPECIAL_DAY" },

};



// WEBPACK FOOTER //
// ./src/constants/holidays/usa/canadaHolidays.ts